import React from "react";

import { ExpressionField } from "components/flowable/ExpressionField";
import FlowableOrgSearch from "components/flowable/FlowableOrgSearch";
import FlowablePersonSearch from "components/flowable/FlowablePersonSearch";
import FlowableUnitSearch from "components/flowable/FlowableUnitSearch";
import NumberComponent from "components/flowable/Number";

import { getColumnConfig } from "../utils/dataTable.utils";
import PortalDate from "./DataTablePortalDate";
import PortalSelect from "./DataTablePortalSelect";

const DataTableColumn = props => {
	// Defensive: fill missing props with safe defaults
	const {
		row = {},
		column = {},
		originalColumn = {},
		rowIndex = 0,
		setCellValue = () => {},
		...rest
	} = props || {};
	const { config = {}, Components = {} } = rest;
	// Defensive: fallback for missing label/id
	const label = column.label || "Label";
	const id = column.id || "text";
	const value = row[label];
	let columnConfig = {};
	try {
		columnConfig = getColumnConfig({ config, column, value, originalColumn, extraScope: rest.data });
	} catch (e) {
		columnConfig = {};
	}

	// Defensive: fallback Components
	const TextComponent = Components.text || (props => <input data-testid="fallback-text" {...props} />);
	const DateComponent = Components.date || (props => <input data-testid="fallback-date" {...props} />);
	const RadioComponent = Components.radio || (props => <input data-testid="fallback-radio" {...props} />);
	const BooleanComponent = Components.boolean || (props => <input data-testid="fallback-boolean" {...props} />);
	const SelectComponent = Components.select || (props => <select data-testid="fallback-select" {...props} />);

	switch (id) {
	case "text":
		return (
			<TextComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "number":
		return (
			<NumberComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "decimal":
		return (
			<NumberComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "date":
		return (
			<PortalDate
				DateComponent={DateComponent}
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "radio":
		return (
			<RadioComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "checkbox":
		return (
			<BooleanComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "dropdownSingle":
	case "dropdownMultiple":
		return (
			<PortalSelect
				SelectComponent={SelectComponent}
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "expressionField":
		return (
			<ExpressionField
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
				extraScope={{ [config.$path]: rest.data }}
			/>
		);
	case "orgFinder":
		return (
			<FlowableOrgSearch
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "personFinder":
		return (
			<FlowablePersonSearch
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	case "unitFinder":
		return (
			<FlowableUnitSearch
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	default:
		return (
			<TextComponent
				{...rest}
				config={columnConfig}
				ckey={label}
				key={label}
				onChange={value => setCellValue(value, rowIndex, label)}
			/>
		);
	}
};

export default DataTableColumn;
